import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PaymentMethod } from '../../../../models/payment-method.model';
import { PaymentMethodService } from '../../../../services/payment-method.service';
import { PaymentMethodModalComponent } from '../../../../components/payment-method-modal/payment-method-modal.component';

@Component({
  selector: 'app-payment-methods-page',
  templateUrl: './payment-methods-page.component.html',
  styleUrl: './payment-methods-page.component.scss'
})
export class PaymentMethodsPageComponent {

  constructor(
    public paymentMethodService: PaymentMethodService,
    private modalService: NgbModal,
  ) {}

  /*
  ██████╗ ███████╗██╗     ███████╗████████╗███████╗
  ██╔══██╗██╔════╝██║     ██╔════╝╚══██╔══╝██╔════╝
  ██║  ██║█████╗  ██║     █████╗     ██║   █████╗
  ██║  ██║██╔══╝  ██║     ██╔══╝     ██║   ██╔══╝
  ██████╔╝███████╗███████╗███████╗   ██║   ███████╗
  ╚═════╝ ╚══════╝╚══════╝╚══════╝   ╚═╝   ╚══════╝

  */
  // region delete
  async delete(
    paymentMethod: PaymentMethod
  ) {
    const flag = confirm(
      `¿Está seguro que desea eliminar el método de pago "${paymentMethod.name}"?`
    );

    if (flag) {
      await this.paymentMethodService.delete(paymentMethod);
    }
  }

  /*
   ██████╗ ██████╗ ███████╗███╗   ██╗
  ██╔═══██╗██╔══██╗██╔════╝████╗  ██║
  ██║   ██║██████╔╝█████╗  ██╔██╗ ██║
  ██║   ██║██╔═══╝ ██╔══╝  ██║╚██╗██║
  ╚██████╔╝██║     ███████╗██║ ╚████║
   ╚═════╝ ╚═╝     ╚══════╝╚═╝  ╚═══╝

  */
  // region open
  open(
    paymentMethod?: PaymentMethod
  ) {
    const modalRef = this.modalService.open(PaymentMethodModalComponent);
    modalRef.componentInstance.paymentMethod = paymentMethod;
  }

}
